var map = {
	"./availablelanguage.js": [
		8332
	],
	"./en.js": [
		9061
	],
	"./fr.js": [
		1980,
		450
	],
	"./messages.js": [
		8440,
		822
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1618;
module.exports = webpackAsyncContext;